import type { FaireProductEntity } from "../../entity_types/product";

export const p_ktpz5kb26x: FaireProductEntity = {
  token: "p_ktpz5kb26x",
  type: "product",
  name: "Gemstone Buddha Bracelet - 12 Pcs",
  brandToken: "b_b8csz3xa8h",
  brandName: "Gypsy Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/3fe2a2a895636ce89c1b22198f0f18455b5088530d6867fd3464e3ee3bc5869e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/49ad236be81119c97e35905841d2bc9cc888cd18220a71a936053bfa89794487.jpeg",
    "https://cdn.faire.com/fastly/0421a778ae9208fd0566e0e813803005878226e6f9bb1834013d4b952fe7046d.jpeg",
    "https://cdn.faire.com/fastly/640d5e1c6d1220955d2c77cfb8d7a95d1b4ffcfc2e149dd1f0017b0f8b69fe7e.jpeg",
    "https://cdn.faire.com/fastly/7bf1605e63ae50c3177ba0051502fdfc2c5adedaec81c795a715ecbe59816d15.jpeg",
    "https://cdn.faire.com/fastly/270c302331e2c5691cef27b4e3098c901c7934bef81985f2a80f14be0913cf53.jpeg",
    "https://cdn.faire.com/fastly/ef855fd7066c5b8a33c932c3bf005ae4e4a5053b47753a8f56a72d5feb481105.jpeg",
    "https://cdn.faire.com/fastly/c735573e80639a0c47268878d76f52ff26adb3e44cbc2f971ed1af7bffcf47a4.jpeg",
    "https://cdn.faire.com/fastly/35282cb29360747f2290e24d0ce4b2cac7325e2b45f1fddee64e6ce1666438fe.jpeg",
    "https://cdn.faire.com/fastly/8b01f1ad6fa6c4c49f16486d65f2b7f452f1d9a87472eac8e55f2042763d5e52.jpeg",
    "https://cdn.faire.com/fastly/8355b29a18ffb35bc863b825f350a0e9feb7d12846f30d83cff6a0786ae8c16b.jpeg",
    "https://cdn.faire.com/fastly/906d3a2c59f75444596e0a9760de40b953a96efce66f9ec1792821ffd361ab02.jpeg",
    "https://cdn.faire.com/fastly/242d4f68f5bd05f76f8bbe51aa6b2c2401826f3704a51b6048325476a946d894.jpeg",
  ],
  priceDollars: 5.52,
  description:
    "If you're looking for an easy-to-wear, adjustable, and handmade gemstone bracelet to help you feel serene and happy, this is it! Inspired by the beauty of ancient Buddhist symbols, the buddha bracelet is a hand-crafted, one-of-a-kind accessory perfect for everyday wear. Made with high quality gemstones , the bracelet features an antique bronze buddha head and 8mm beads. The size is adjustable to fit almost any wrist. \n\nPack Specs\nIncludes Assortment of Gemstone Buddha Bracelets Below\n*Lava\n*Black Onyx \n*Turquoise\n*Wood\n*Howlite\n*Apatite\n*Sodalite\n*Cherry Quartz\n*Moonstone\n*African Turquoise",
  tags: [],
  msrpDollars: 11.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:56.347Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
